(function () {
  function log() { console.log.apply(console, arguments); }

  function hasCookie(name) {
    return document.cookie.split('; ').some(function (c) { return c.indexOf(name + '=') === 0; });
  }

  function readCY() {
    if (!window.getCkyConsent) return null;
    try { return window.getCkyConsent(); } catch (e) { return {__err: e && (e.message || e)}; }
  }

  function desiredFromCY(cy) {
    if (!cy || cy.__err) return null;
    var c = cy.categories || {};
    var hasCategories = Object.keys(c).length > 0;
    var hasConsentCookie = hasCookie('cookieyes-consent');
    var hasConsentId = !!cy.consentID;

    // Key change: allow inherited consent even if isUserActionCompleted is false
    var okToSync = (cy.isUserActionCompleted === true) || (hasCategories && (hasConsentId || hasConsentCookie));

    return okToSync ? {
      preferences: !!c.functional,
      analytics: !!c.analytics,
      marketing: !!c.advertisement
    } : null;
  }

  function loadShopifyPrivacy(cb) {
    if (!window.Shopify || !Shopify.loadFeatures) return cb('Shopify.loadFeatures missing');
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err) return cb(err);
      if (!Shopify.customerPrivacy) return cb('Shopify.customerPrivacy missing');
      cb(null, Shopify.customerPrivacy);
    });
  }

  function sync(tag) {
    var cy = readCY();
    log('[CY]', tag, cy);
    log('[CY]', tag, 'cookieyes-consent cookie present?', hasCookie('cookieyes-consent'));

    var desired = desiredFromCY(cy);
    log('[BRIDGE]', tag, 'desired:', desired);

    if (!desired) return false;

    loadShopifyPrivacy(function (err, cp) {
      if (err) return log('[SHOPIFY]', tag, 'privacy api load error:', err);

      var cur = cp.currentVisitorConsent();
      log('[SHOPIFY]', tag, 'currentVisitorConsent:', cur);

      var needs =
        cur.preferences === '' || cur.analytics === '' || cur.marketing === '' ||
        (cur.preferences === 'yes') !== desired.preferences ||
        (cur.analytics === 'yes') !== desired.analytics ||
        (cur.marketing === 'yes') !== desired.marketing;

      log('[SHOPIFY]', tag, 'needsUpdate?', needs);

      if (!needs) return;

      cp.setTrackingConsent(desired, function (res) {
        log('[SHOPIFY]', tag, 'setTrackingConsent callback:', res);
        log('[SHOPIFY]', tag, 'after:', cp.currentVisitorConsent());
      });
    });

    return true;
  }

  window.addEventListener('cookieyes_banner_loaded', function () {
    log('[EVENT] cookieyes_banner_loaded');
    sync('banner_loaded');
  });

  // Poll briefly because inherited consent might be available slightly after load
  var i = 0;
  var t = setInterval(function () {
    i++;
    var done = sync('poll_' + i);
    if (done || i >= 20) clearInterval(t);
  }, 500);

})();